'use strict';

var _ = require('lodash');
var MarketMappedBookingsTransformerFactory = function MarketMappedBookingsTransformerFactory(DataTransformer) {
  function MarketMappedBookingsTransformer(targetType, priority) {
    DataTransformer.call(this);
    this.sourceType = 'market-mapped-bookings';
    this.targetType = targetType;
    this.priority = priority || 0;
  }
  MarketMappedBookingsTransformer.prototype = Object.create(DataTransformer.prototype);
  MarketMappedBookingsTransformer.constructor = MarketMappedBookingsTransformer;
  MarketMappedBookingsTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  MarketMappedBookingsTransformer.prototype.isCacheable = function () {
    return true;
  };
  MarketMappedBookingsTransformer.prototype.getCacheKey = function (metrics) {
    return this.sourceType + '-' + metrics.join('-');
  };
  MarketMappedBookingsTransformer.prototype.transform = function (data) {
    return _.get(data, 'domain.aggregatedTripBookings', []);
  };
  return MarketMappedBookingsTransformer;
};
MarketMappedBookingsTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = MarketMappedBookingsTransformerFactory;